var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-crm-wrapper"},[_c('Sidebar',{on:{"navigateTo":_vm.switchTab}}),(_vm.selected_tab == 'school_partners')?_c('SchoolMatrix'):_vm._e(),(_vm.selected_tab == 'lia')?_c('Lia'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }